import { useQuery } from '@apollo/client';
import {
  GetOrder,
  GetOrderVariables,
} from '_graphql/queries/__generated__/GetOrder';
import { getOrderItem } from '_graphql/queries/orders';

export const useOrderItem = (orderItemId?: string) => {
  const { data, ...rest } = useQuery<GetOrder, GetOrderVariables>(
    getOrderItem,
    {
      variables: {
        filter: {
          id: {
            eq: orderItemId,
          },
        },
      },
      skip: !orderItemId,
      fetchPolicy: 'network-only',
    }
  );

  return {
    orderItem: data?.getOrder ?? null,
    ...rest,
  };
};
